function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

class HomeFilter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.href = this.getAttribute('href-target');
    this.filters = this.querySelectorAll('.filter');
    this.searchButton = this.querySelector('.home-filter-search-button');
    this.filterMap = new Map();

    // check if filters (as select) change value and add query (option value) to this.filteredHref
    this.filters.forEach((filter) => {
      const value = filter.querySelector('input[type="radio"]:checked').value;
      const radios = filter.querySelectorAll('input[type="radio"]');

      this.filterMap.set(filter.getAttribute('key'), value);

      radios.forEach((radio) => {
        radio.addEventListener('input', (e) => {
          this.updateMap(e.target, filter);
        });
      });

      this.updateHref();
      this.clickOutsideClose(filter);
    });
  }

  updateMap(target, filter) {
    this.filterMap.set(filter.getAttribute('key'), target.value);
    this.updateHref();

    this.updateSummary(target, filter);
  }

  updateSummary(target, filter) {
    const summary = filter.querySelector('summary .selected-value');

    if (summary) {
      summary.textContent = target.nextElementSibling.textContent;
    }
  }

  updateHref() {
    const hrefWithQueries = `${this.href}?${Array.from(this.filterMap)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')}`;

    this.searchButton.href = hrefWithQueries;
  }

  clickOutsideClose(details) {
    document.addEventListener('click', (e) => {
      if (!details.contains(e.target)) {
        details.removeAttribute('open');
      }
    });
  }
}

if (!customElements.get('mca-home-filter')) {
  customElements.define('mca-home-filter', HomeFilter);
}
